<script lang="ts">
	import { onMount } from 'svelte';
	import { page } from '$app/stores';
	let isScrolled = false;

	onMount(() => {
		window.addEventListener('scroll', () => {
			if (window.scrollY > 50) {
				isScrolled = true;
			} else {
				isScrolled = false;
			}
		});
	});
</script>

<div class="hidden lg:block">
	<nav class="fixed top-0 w-full z-40 navbar-transition">
		<!-- Navbar Logo Atas -->
		<div
			class="border-b-[1px] border-white transition-all duration-300 ease-in-out"
			class:hidden={isScrolled}
		>
			<div class="flex justify-between items-center px-10 py-5">
				<a data-sveltekit-reload href="/">
					<img src="/images/sohamlogowhite.png" alt="logo" class="h-8" aria-label="logo" />
				</a>
				<div class="flex items-center gap-3">
					<div class="flex items-center gap-3">
						<a
							data-sveltekit-reload href="mailto:info@sohamwellnesscenter.com"
							class="flex items-center gap-2 text-sm text-white"
						>
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
								<path
									d="M17.5 3.75H2.5C2.33424 3.75 2.17527 3.81585 2.05806 3.93306C1.94085 4.05027 1.875 4.20924 1.875 4.375V15C1.875 15.3315 2.0067 15.6495 2.24112 15.8839C2.47554 16.1183 2.79348 16.25 3.125 16.25H16.875C17.2065 16.25 17.5245 16.1183 17.7589 15.8839C17.9933 15.6495 18.125 15.3315 18.125 15V4.375C18.125 4.20924 18.0592 4.05027 17.9419 3.93306C17.8247 3.81585 17.6658 3.75 17.5 3.75ZM15.893 5L10 10.4023L4.10703 5H15.893ZM16.875 15H3.125V5.79609L9.57734 11.7109C9.69265 11.8168 9.84348 11.8755 10 11.8755C10.1565 11.8755 10.3074 11.8168 10.4227 11.7109L16.875 5.79609V15Z"
									fill="white"
								/>
							</svg>
							info@sohamwellnesscenter.com
						</a>
						<a
							data-sveltekit-reload href="tel:+62 821 4618 6424"
							class="flex items-center gap-2 text-sm text-white ps-3"
							style="border-left: 1px solid var(--white, #FFF);"
						>
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
								<path
									d="M17.3727 12.3797L13.6922 10.7305L13.682 10.7258C13.491 10.6441 13.2825 10.6113 13.0756 10.6304C12.8687 10.6495 12.6698 10.7198 12.4969 10.8352C12.4765 10.8486 12.457 10.8632 12.4383 10.8789L10.5367 12.5C9.33204 11.9148 8.08829 10.6805 7.50313 9.4914L9.12657 7.56094C9.14219 7.5414 9.15704 7.52187 9.1711 7.50078C9.28394 7.32836 9.35239 7.13072 9.37039 6.92545C9.38838 6.72017 9.35534 6.51364 9.27423 6.32422V6.31484L7.62032 2.62812C7.51309 2.38067 7.3287 2.17454 7.09468 2.0405C6.86067 1.90645 6.58958 1.85169 6.32188 1.88437C5.26326 2.02368 4.29155 2.54357 3.58824 3.34695C2.88492 4.15033 2.49809 5.18226 2.50001 6.25C2.50001 12.4531 7.54688 17.5 13.75 17.5C14.8177 17.5019 15.8497 17.1151 16.6531 16.4118C17.4564 15.7085 17.9763 14.7367 18.1156 13.6781C18.1484 13.4105 18.0937 13.1395 17.9598 12.9055C17.8259 12.6715 17.62 12.487 17.3727 12.3797ZM13.75 16.25C11.0987 16.2471 8.55687 15.1926 6.68214 13.3179C4.8074 11.4431 3.7529 8.90127 3.75001 6.25C3.74707 5.4871 4.02192 4.74921 4.52324 4.17414C5.02456 3.59907 5.71806 3.22614 6.47423 3.125C6.47392 3.12812 6.47392 3.13126 6.47423 3.13437L8.11485 6.80625L6.50001 8.73906C6.48362 8.75792 6.46873 8.77803 6.45548 8.79922C6.33791 8.97962 6.26894 9.18734 6.25525 9.40223C6.24157 9.61713 6.28362 9.83192 6.37735 10.0258C7.08516 11.4734 8.54376 12.9211 10.007 13.6281C10.2023 13.721 10.4184 13.7616 10.634 13.746C10.8497 13.7304 11.0576 13.6591 11.2375 13.5391C11.2576 13.5255 11.2769 13.5109 11.2953 13.4953L13.1945 11.875L16.8664 13.5195C16.8664 13.5195 16.8727 13.5195 16.875 13.5195C16.7751 14.2768 16.4027 14.9717 15.8275 15.4742C15.2524 15.9768 14.5138 16.2526 13.75 16.25Z"
									fill="white"
								/>
							</svg>
							+62 821 4618 6424
						</a>
					</div>
				</div>
			</div>
		</div>

		<!-- Navbar Bawah -->
		<div
			class="flex justify-between items-center px-10 py-4"
			class:bgscroll={isScrolled}
			class:bg-transparent={!isScrolled}
		>
			<div class="flex items-center gap-5">
				<div class="w-auto">
					<ul class="flex items-center gap-5">
						<li>
							<a data-sveltekit-reload href="/" class="block py-2 px-3 text-sm font-semibold text-white uppercase">Home</a
							>
						</li>
						<li>
							<a data-sveltekit-reload href="/wellness" class="block py-2 px-3 text-sm font-semibold text-white uppercase"
								>Wellness</a
							>
						</li>
						<li>
							<a
								data-sveltekit-reload href="/membership"
								class="block py-2 px-3 text-sm font-semibold text-white uppercase">Membership</a
							>
						</li>
						<li>
							<a
								data-sveltekit-reload href="/facilities"
								class="block py-2 px-3 text-sm font-semibold text-white uppercase">Facilities</a
							>
						</li>
						<li>
							<a data-sveltekit-reload href="/about-us" class="block py-2 px-3 text-sm font-semibold text-white uppercase"
								>About Us</a
							>
						</li>
					</ul>
				</div>
			</div>
			<a data-sveltekit-reload href="mailto:info@sohamwellnesscenter.com" class="text-white text-sm border-[1px] border-white px-5 py-3">APPOINTMENT</a>
		</div>
	</nav>
</div>
<div class="block lg:hidden">
	<div class="fixed bottom-10 w-full z-20">
		<div class="px-2">
			<div class="bg-white grid grid-cols-5 gap-2 px-5 py-2 rounded-2xl shadow-xl">
				<a data-sveltekit-reload href="/" class="flex flex-col items-center text-[#41818A] font-medium text-xs gap-2">
					<div class="p-[1rem]" class:active-link={$page.url.pathname === `/`}>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="28"
							height="28"
							viewBox="0 0 28 28"
							fill="none"
						>
							<path
								d="M23.9345 11.3498L15.1845 3.09422C15.1803 3.09049 15.1762 3.08647 15.1725 3.08219C14.8503 2.78921 14.4305 2.62686 13.9951 2.62686C13.5596 2.62686 13.1398 2.78921 12.8177 3.08219L12.8056 3.09422L4.06547 11.3498C3.88719 11.5138 3.74487 11.7129 3.64754 11.9347C3.5502 12.1565 3.49996 12.3961 3.5 12.6383V22.75C3.5 23.2141 3.68437 23.6593 4.01256 23.9874C4.34075 24.3156 4.78587 24.5 5.25 24.5H10.5C10.9641 24.5 11.4092 24.3156 11.7374 23.9874C12.0656 23.6593 12.25 23.2141 12.25 22.75V17.5H15.75V22.75C15.75 23.2141 15.9344 23.6593 16.2626 23.9874C16.5908 24.3156 17.0359 24.5 17.5 24.5H22.75C23.2141 24.5 23.6592 24.3156 23.9874 23.9874C24.3156 23.6593 24.5 23.2141 24.5 22.75V12.6383C24.5 12.3961 24.4498 12.1565 24.3525 11.9347C24.2551 11.7129 24.1128 11.5138 23.9345 11.3498ZM22.75 22.75H17.5V17.5C17.5 17.0359 17.3156 16.5908 16.9874 16.2626C16.6592 15.9344 16.2141 15.75 15.75 15.75H12.25C11.7859 15.75 11.3408 15.9344 11.0126 16.2626C10.6844 16.5908 10.5 17.0359 10.5 17.5V22.75H5.25V12.6383L5.26203 12.6273L14 4.375L22.7391 12.6252L22.7511 12.6361L22.75 22.75Z"
								fill="#41818A"
							/>
						</svg>
					</div>

					Home</a
				>
				<a
					data-sveltekit-reload href="/wellness"
					class="flex flex-col items-center text-[#41818A] font-medium text-xs gap-2"
				>
					<div class="p-[1rem]" class:active-link={$page.url.pathname === `/wellness`}>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="29"
							height="28"
							viewBox="0 0 29 28"
							fill="none"
						>
							<path
								d="M27.3877 13.3033C27.276 13.1072 27.1265 12.9353 26.9477 12.7976C26.7689 12.66 26.5645 12.5593 26.3464 12.5016C25.5552 12.2979 24.7375 12.216 23.9216 12.2587C24.3591 10.0877 24.0309 8.37047 23.6963 7.35219C23.5628 6.9339 23.2784 6.58028 22.8985 6.36028C22.5185 6.14028 22.0703 6.06966 21.6411 6.16219C20.5281 6.41006 19.4698 6.85932 18.5184 7.48781C17.8217 6.06445 16.8072 4.82021 15.5533 3.85109C15.2494 3.62319 14.8798 3.5 14.5 3.5C14.1202 3.5 13.7506 3.62319 13.4467 3.85109C12.1925 4.81992 11.178 6.06424 10.4816 7.48781C9.53017 6.85932 8.47188 6.41006 7.35891 6.16219C6.92972 6.06966 6.48146 6.14028 6.10151 6.36028C5.72156 6.58028 5.43716 6.9339 5.30375 7.35219C4.97563 8.37047 4.6475 10.0866 5.07844 12.2587C4.26252 12.216 3.44484 12.2979 2.65359 12.5016C2.43549 12.5593 2.23108 12.66 2.0523 12.7976C1.87352 12.9353 1.72396 13.1072 1.61234 13.3033C1.49554 13.5042 1.41991 13.7263 1.38986 13.9567C1.35981 14.1871 1.37596 14.4212 1.43734 14.6453C1.80813 16.0202 2.94672 18.6353 6.39531 20.6959C9.84391 22.7566 12.8736 22.75 14.5055 22.75C16.1373 22.75 19.1725 22.75 22.5992 20.6959C26.0478 18.6353 27.1864 16.0202 27.5572 14.6453C27.6194 14.4216 27.6364 14.1877 27.6073 13.9573C27.5782 13.7268 27.5036 13.5045 27.3877 13.3033ZM6.96844 7.89031C6.96975 7.88488 6.97308 7.88016 6.97776 7.87711C6.98243 7.87406 6.9881 7.87291 6.9936 7.87391C8.01132 8.10381 8.97173 8.53806 9.81656 9.15031C9.43189 10.4087 9.24085 11.7183 9.25 13.0342C9.25 15.0839 9.66234 16.753 10.2464 18.0961C9.41608 17.265 8.69763 16.3293 8.10922 15.3125C6.13828 11.8803 6.54844 9.1875 6.96844 7.89031ZM7.29656 19.1942C4.37953 17.453 3.43344 15.318 3.125 14.1859C3.9298 13.9878 4.76493 13.9444 5.58594 14.058C5.86003 14.7922 6.19478 15.5023 6.58672 16.1809C7.54906 17.8401 8.80983 19.307 10.3055 20.5078C9.24787 20.2037 8.23478 19.7621 7.29219 19.1942H7.29656ZM14.5 20.825C13.4795 20.0659 11 17.7373 11 13.0342C11 8.38906 13.4478 6.04187 14.5 5.25C15.5522 6.04406 18 8.39125 18 13.0364C18 17.7373 15.5205 20.0659 14.5 20.825ZM19.1834 9.15031C20.0284 8.53844 20.9888 8.10457 22.0064 7.875C22.0119 7.87401 22.0176 7.87515 22.0222 7.8782C22.0269 7.88125 22.0303 7.88598 22.0316 7.89141C22.4516 9.1875 22.8617 11.8803 20.8908 15.3125C20.3029 16.3306 19.5844 17.2675 18.7536 18.0994C19.3377 16.7584 19.75 15.0872 19.75 13.0375C19.7595 11.7205 19.5684 10.4098 19.1834 9.15031ZM25.875 14.1881C25.572 15.3092 24.6281 17.4486 21.7089 19.1942C20.7663 19.7617 19.7532 20.203 18.6956 20.5067C20.1913 19.3059 21.452 17.839 22.4144 16.1798C22.8063 15.5012 23.1411 14.7911 23.4152 14.0569C24.2359 13.9438 25.0707 13.988 25.875 14.187V14.1881Z"
								fill="#41818A"
							/>
						</svg>
					</div>

					Wellness</a
				>
				<a
					data-sveltekit-reload href="/membership"
					class="flex flex-col items-center text-[#41818A] font-medium text-xs gap-2"
				>
					<div class="p-[1rem]" class:active-link={$page.url.pathname === `/membership`}>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="28"
							height="28"
							viewBox="0 0 28 28"
							fill="none"
						>
							<path
								d="M25.375 11.375C25.6071 11.375 25.8296 11.2828 25.9937 11.1187C26.1578 10.9546 26.25 10.7321 26.25 10.5V7C26.25 6.53587 26.0656 6.09075 25.7374 5.76256C25.4092 5.43437 24.9641 5.25 24.5 5.25H3.5C3.03587 5.25 2.59075 5.43437 2.26256 5.76256C1.93437 6.09075 1.75 6.53587 1.75 7V10.5C1.75 10.7321 1.84219 10.9546 2.00628 11.1187C2.17038 11.2828 2.39294 11.375 2.625 11.375C3.32119 11.375 3.98887 11.6516 4.48116 12.1438C4.97344 12.6361 5.25 13.3038 5.25 14C5.25 14.6962 4.97344 15.3639 4.48116 15.8562C3.98887 16.3484 3.32119 16.625 2.625 16.625C2.39294 16.625 2.17038 16.7172 2.00628 16.8813C1.84219 17.0454 1.75 17.2679 1.75 17.5V21C1.75 21.4641 1.93437 21.9092 2.26256 22.2374C2.59075 22.5656 3.03587 22.75 3.5 22.75H24.5C24.9641 22.75 25.4092 22.5656 25.7374 22.2374C26.0656 21.9092 26.25 21.4641 26.25 21V17.5C26.25 17.2679 26.1578 17.0454 25.9937 16.8813C25.8296 16.7172 25.6071 16.625 25.375 16.625C24.6788 16.625 24.0111 16.3484 23.5188 15.8562C23.0266 15.3639 22.75 14.6962 22.75 14C22.75 13.3038 23.0266 12.6361 23.5188 12.1438C24.0111 11.6516 24.6788 11.375 25.375 11.375ZM3.5 18.2875C4.489 18.0867 5.37817 17.5501 6.01683 16.7687C6.6555 15.9873 7.00439 15.0092 7.00439 14C7.00439 12.9908 6.6555 12.0127 6.01683 11.2313C5.37817 10.4499 4.489 9.91333 3.5 9.7125V7H9.625V21H3.5V18.2875ZM24.5 18.2875V21H11.375V7H24.5V9.7125C23.511 9.91333 22.6218 10.4499 21.9832 11.2313C21.3445 12.0127 20.9956 12.9908 20.9956 14C20.9956 15.0092 21.3445 15.9873 21.9832 16.7687C22.6218 17.5501 23.511 18.0867 24.5 18.2875Z"
								fill="#41818A"
							/>
						</svg>
					</div>

					Membership</a
				>
				<a
					data-sveltekit-reload href="/facilities"
					class="flex flex-col items-center text-[#41818A] font-medium text-xs gap-2"
				>
					<div class="p-[1rem]" class:active-link={$page.url.pathname === `/facilities`}>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="29"
							height="28"
							viewBox="0 0 29 28"
							fill="none"
						>
							<path
								d="M10.125 16.3395C10.3571 16.3395 10.5796 16.2473 10.7437 16.0833C10.9078 15.9192 11 15.6966 11 15.4645V14H18V15.6723C18 15.9044 18.0922 16.127 18.2563 16.2911C18.4204 16.4552 18.6429 16.5473 18.875 16.5473C19.1071 16.5473 19.3296 16.4552 19.4937 16.2911C19.6578 16.127 19.75 15.9044 19.75 15.6723V3.5C19.75 3.26794 19.6578 3.04538 19.4937 2.88128C19.3296 2.71719 19.1071 2.625 18.875 2.625C18.6429 2.625 18.4204 2.71719 18.2563 2.88128C18.0922 3.04538 18 3.26794 18 3.5V5.25H11V3.5C11 3.26794 10.9078 3.04538 10.7437 2.88128C10.5796 2.71719 10.3571 2.625 10.125 2.625C9.89294 2.625 9.67038 2.71719 9.50628 2.88128C9.34219 3.04538 9.25 3.26794 9.25 3.5V15.4645C9.25 15.6966 9.34219 15.9192 9.50628 16.0833C9.67038 16.2473 9.89294 16.3395 10.125 16.3395ZM11 12.25V10.5H18V12.25H11ZM18 7V8.75H11V7H18ZM3.125 18.375C3.125 18.1429 3.21719 17.9204 3.38128 17.7563C3.54538 17.5922 3.76794 17.5 4 17.5C5.57719 17.5 6.42703 18.0666 7.11062 18.5216C7.71875 18.9284 8.20219 19.25 9.25 19.25C10.2978 19.25 10.7812 18.9284 11.3894 18.5216C12.0719 18.0666 12.9206 17.5 14.4989 17.5C16.0772 17.5 16.927 18.0666 17.6095 18.5216C18.2198 18.9284 18.7033 19.25 19.75 19.25C20.7967 19.25 21.2812 18.9284 21.8894 18.5216C22.573 18.0666 23.4206 17.5 25 17.5C25.2321 17.5 25.4546 17.5922 25.6187 17.7563C25.7828 17.9204 25.875 18.1429 25.875 18.375C25.875 18.6071 25.7828 18.8296 25.6187 18.9937C25.4546 19.1578 25.2321 19.25 25 19.25C23.9522 19.25 23.4688 19.5716 22.8606 19.9784C22.177 20.4334 21.3294 21 19.75 21C18.1706 21 17.3219 20.4334 16.6394 19.9784C16.0312 19.5716 15.5467 19.25 14.5 19.25C13.4533 19.25 12.9688 19.5716 12.3606 19.9784C11.6781 20.4334 10.8294 21 9.25109 21C7.67281 21 6.82406 20.4334 6.14047 19.9784C5.53125 19.5716 5.04781 19.25 4 19.25C3.76794 19.25 3.54538 19.1578 3.38128 18.9937C3.21719 18.8296 3.125 18.6071 3.125 18.375ZM25.875 22.75C25.875 22.9821 25.7828 23.2046 25.6187 23.3687C25.4546 23.5328 25.2321 23.625 25 23.625C23.9522 23.625 23.4688 23.9466 22.8606 24.3534C22.177 24.8084 21.3294 25.375 19.75 25.375C18.1706 25.375 17.3219 24.8084 16.6394 24.3534C16.0312 23.9466 15.5467 23.625 14.5 23.625C13.4533 23.625 12.9688 23.9466 12.3606 24.3534C11.6781 24.8084 10.8294 25.375 9.25109 25.375C7.67281 25.375 6.82406 24.8084 6.14047 24.3534C5.53125 23.9466 5.04781 23.625 4 23.625C3.76794 23.625 3.54538 23.5328 3.38128 23.3687C3.21719 23.2046 3.125 22.9821 3.125 22.75C3.125 22.5179 3.21719 22.2954 3.38128 22.1313C3.54538 21.9672 3.76794 21.875 4 21.875C5.57719 21.875 6.42703 22.4416 7.11062 22.8966C7.71875 23.3034 8.20219 23.625 9.25 23.625C10.2978 23.625 10.7812 23.3034 11.3894 22.8966C12.0719 22.4416 12.9206 21.875 14.4989 21.875C16.0772 21.875 16.927 22.4416 17.6095 22.8966C18.2198 23.3034 18.7033 23.625 19.75 23.625C20.7967 23.625 21.2812 23.3034 21.8894 22.8966C22.573 22.4416 23.4206 21.875 25 21.875C25.2321 21.875 25.4546 21.9672 25.6187 22.1313C25.7828 22.2954 25.875 22.5179 25.875 22.75Z"
								fill="#41818A"
							/>
						</svg>
					</div>

					Facilities</a
				>
				<a
					data-sveltekit-reload href="/about-us"
					class="flex flex-col items-center text-[#41818A] font-medium text-xs gap-2"
				>
					<div class="p-[1rem]" class:active-link={$page.url.pathname === `/about-us`}>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="28"
							height="28"
							viewBox="0 0 28 28"
							fill="none"
						>
							<path
								d="M24.3217 17.3316L19.1691 15.0226L19.1548 15.0161C18.8873 14.9017 18.5955 14.8558 18.3058 14.8825C18.0161 14.9092 17.7377 15.0078 17.4956 15.1692C17.4671 15.188 17.4397 15.2085 17.4136 15.2305L14.7514 17.5C13.0648 16.6808 11.3236 14.9526 10.5044 13.288L12.7772 10.5853C12.7991 10.558 12.8198 10.5306 12.8395 10.5011C12.9975 10.2597 13.0933 9.983 13.1185 9.69562C13.1437 9.40824 13.0975 9.11909 12.9839 8.8539V8.84077L10.6684 3.67937C10.5183 3.33294 10.2602 3.04435 9.93254 2.85669C9.60492 2.66903 9.2254 2.59236 8.85062 2.63812C7.36856 2.83314 6.00816 3.56099 5.02352 4.68572C4.03887 5.81045 3.49731 7.25515 3.49999 8.74999C3.49999 17.4344 10.5656 24.5 19.25 24.5C20.7448 24.5027 22.1895 23.9611 23.3143 22.9765C24.439 21.9918 25.1668 20.6314 25.3619 19.1494C25.4077 18.7747 25.3312 18.3953 25.1437 18.0677C24.9563 17.7401 24.6679 17.4819 24.3217 17.3316ZM19.25 22.75C15.5382 22.7459 11.9796 21.2696 9.35498 18.645C6.73034 16.0204 5.25405 12.4618 5.24999 8.74999C5.24588 7.68193 5.63068 6.64889 6.33252 5.8438C7.03436 5.0387 8.00526 4.5166 9.0639 4.37499C9.06347 4.37936 9.06347 4.38375 9.0639 4.38812L11.3608 9.52874L9.09999 12.2347C9.07705 12.2611 9.0562 12.2892 9.03765 12.3189C8.87306 12.5715 8.7765 12.8623 8.75734 13.1631C8.73818 13.464 8.79706 13.7647 8.92828 14.0361C9.91921 16.0628 11.9612 18.0895 14.0098 19.0794C14.2832 19.2094 14.5857 19.2662 14.8876 19.2443C15.1896 19.2225 15.4807 19.1227 15.7325 18.9547C15.7606 18.9358 15.7876 18.9153 15.8134 18.8934L18.4723 16.625L23.613 18.9273C23.613 18.9273 23.6217 18.9273 23.625 18.9273C23.4851 19.9875 22.9638 20.9603 22.1586 21.6639C21.3533 22.3675 20.3193 22.7536 19.25 22.75Z"
								fill="#41818A"
							/>
						</svg>
					</div>

					About Us</a
				>
			</div>
		</div>
	</div>
</div>

<style>
	.bgscroll {
		background: rgba(0, 0, 0, 0.2);

		backdrop-filter: blur(5px);
	}
	.active-link {
		border-radius: 12px;
		background: #e4ebf0;
		padding: 1rem;
	}
</style>
